import { EntityWithStatusService } from './EntityWithStatusService';
import { IEntityChildren, IEntityDescription1, IZCoreAIChat } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';

export class ZCoreAIChatService extends EntityWithStatusService<IZCoreAIChat> {
    //public readonly parentEntities = ['ManagedByL2', 'ManagedByL3'];
    protected childrenEntities = ['ZCoreAIChatUsers($expand=User)'];

    constructor() {
        super(`/ZCoreAIChats`);
    }

    public readAllForList(includeClosed?: boolean, appID?: number): Promise<IZCoreAIChat[]> {
        return this.readAll(
            `?$select=ID,Title,LastPrompt,TotalPrompts,CreatedOn,LastPromptAt`
            + `&$orderby=ID desc`
            + `&$expand=`
            + `ZCoreAIChatUsers($select=ID;$expand=User($select=Title))`
            //+ `&$expand=OwnerL1($select=Title),OwnerL2($select=Title),OwnerL3($select=Title),EntityStatus($select=Title),PPObjectiveVisions($expand=Vision($select=ID,Title)),Portfolios($select=ID)`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
            + (appID ? ` and AppID eq ${appID}` : ``)
        );
    }


}